export var VaultValidationErrorList = [
    "insufficientBalance",
    "maxExceeded",
    "capacityOverflow",
    "withdrawLimitExceeded",
    "withdrawAmountStaked",
    "vaultFull",
    "maxDeposited",
    "allBalanceStaked",
    "withdrawLimitReached",
    "existingWithdraw",
];
export var VaultInputValidationErrorList = [
    "insufficientBalance",
    "maxExceeded",
    "capacityOverflow",
    "withdrawLimitExceeded",
    "withdrawAmountStaked",
    "existingWithdraw",
];
//# sourceMappingURL=types.js.map